module.exports = __webpack_public_path__ + "static/media/BookOpenText.8abb57b1.svg";